export const state = () => ({
  meta: null,
  stage: null,
  stageBlue: null,
  contact: null,
  crossLinkage: null,
  more: null,
  downloadFileExists: false,
  relatedArticles: []
  // consultingHours: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  stage(state) {
    return state.stage
  },
  stageBlue(state) {
    return state.stageBlue
  },
  more(state) {
    return state.more
  },
  relatedArticles(state) {
    return state.relatedArticles
  },
  contact(state) {
    return state.contact
  },
  crossLinkage(state) {
    return state.crossLinkage
  },
  downloadFileExists(state) {
    return state.downloadFileExists
  }
  // consultingHours(state) {
  //   return state.consultingHours
  // }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setStageBlue(state, { data }) {
    state.stageBlue = data
  },
  setMore(state, { data }) {
    state.more = data
    state.relatedArticles = []
  },
  setDownloadFileExists(state, { data }) {
    state.downloadFileExists = data
  },
  setRelatedArticles(state, { data, reset, folderName }) {
    if (reset || !data) {
      state.relatedArticles = []
    } else if (folderName) {
      state.relatedArticles.push({
        folderName: folderName,
        headline: data.generic.headline,
        text: `${data.generic.text.slice(0, 100)}...`,
        linkText:
          this.getters['pages/services/detail-pages/subpage/more'].generic
            .card_link_text,
        type: data.generic.type,
        imageUrl: `/homepage/insights/${folderName}/image.jpg`,
        path: `/insights/${folderName}`
      })
      state.relatedArticles = Array.from(new Set(state.relatedArticles))
      state.relatedArticles = state.relatedArticles.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.folderName === value.folderName)
      )
    }
  },
  setContact(state, { data }) {
    state.contact = data
  },
  setCrossLinkage(state, { data }) {
    state.crossLinkage = data
  },
  setConsultingHours(state, { data }) {
    state.consultingHours = data
  }
}
export const actions = {
  getMeta({ commit, rootState }, { detailFolder, subDetailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/services/${detailFolder}/${subDetailFolder}/meta.json`
      )
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }, { detailFolder, subDetailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/services/${detailFolder}/${subDetailFolder}/stage.json`
      )
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStageBlue({ commit, rootState }, { detailFolder, subDetailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/services/${detailFolder}/${subDetailFolder}/stage_blue.json`
      )
      .then((res) => {
        commit('setStageBlue', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getMore({ commit, rootState }, { detailFolder, subDetailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/services/${detailFolder}/${subDetailFolder}/more.json`
      )
      .then((res) => {
        commit('setMore', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
        commit('setMore', { data: null })
      })
  },
  getRelatedArticles({ commit, rootState }, { folderName }) {
    commit('setRelatedArticles', {
      reset: true
    })
    return this.$axios
      .get(
        `${rootState.language}/homepage/insights/${folderName}/general_information.json`
      )
      .then((res) => {
        commit('setRelatedArticles', { data: res.data, folderName: folderName })
      })
      .catch((err) => {
        console.error(err)
        commit('setRelatedArticles', { reset: true })
      })
  },
  checkDownloadFile({ commit }, { path }) {
    // let formData = new FormData()
    // formData.append('path', path)
    commit('setDownloadFileExists', { data: false })
    return this.$axios
      .post('/api/file/exists', { path: path })
      .then((res) => {
        if (res.data && res.data.exists) {
          commit('setDownloadFileExists', { data: res.data.exists })
        } else {
          commit('setDownloadFileExists', { data: false })
        }
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContact({ commit, rootState }, { detailFolder, subDetailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/services/${detailFolder}/${subDetailFolder}/contact.json`
      )
      .then((res) => {
        commit('setContact', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getCrossLinkage({ commit, rootState }, { detailFolder, subDetailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/services/${detailFolder}/${subDetailFolder}/cross_linkage.json`
      )
      .then((res) => {
        commit('setCrossLinkage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
  // getConsultingHours({ commit, rootState }, { detailFolder, subDetailFolder }) {
  //   return this.$axios
  //     .get(
  //       `${rootState.language}/homepage/services/${detailFolder}/${subDetailFolder}/consulting_hours.json`
  //     )
  //     .then((res) => {
  //       commit('setConsultingHours', { data: res.data })
  //     })
  //     .catch((err) => {
  //       console.error(err)
  //     })
  // }
}
